import { render } from "./publicEducational.vue?vue&type=template&id=7f06ae80"
import script from "./publicEducational.vue?vue&type=script&lang=js"
export * from "./publicEducational.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__